export default __webpack_public_path__ + "static/media/War Mammoth.b6b5f518.jpg";